// extracted by mini-css-extract-plugin
module.exports = {"root":"LabelButton_root__Q4_HQ","defaultColor":"LabelButton_defaultColor__1pZ2m","uppercase":"LabelButton_uppercase__B92mx","rootFullWidth":"LabelButton_rootFullWidth__U912a"};